var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKbvV16TrendArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 4.8,
    viewBox: "0 0 6 4.8",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3,0 L6,4.8 H0 Z",
    fill: "#46a452"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbvV16TrendArrowUp);
export default __webpack_public_path__ + "static/media/kbv-v16-trend-arrow-up.dd63172147573d532fba4c8c7f6925c8.svg";
export { ForwardRef as ReactComponent };